import { motion } from 'framer-motion';

interface Purchase {
  merchant: string;
  amount: number;
  date: string;
}

interface TopPurchaseBoxProps {
  purchase: Purchase;
}

export const TopPurchaseBox = ({ purchase }: TopPurchaseBoxProps) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  return (
    <div className="relative">
      {/* Shadow box */}
      <div className="absolute top-[4px] left-[4px] w-full h-full bg-black rounded-xl" />
      
      {/* Main content box */}
      <div className="bg-white rounded-xl p-4 relative border-2 border-black">
        <div className="text-[#221A51]/60 text-sm mb-3">Biggest Purchase</div>
        <div className="flex justify-between items-center">
          <div className="min-w-0 flex-1 mr-4">
            <div className="font-extrabold text-xl leading-tight text-[#221A51] truncate whitespace-nowrap">
              {purchase.merchant}
            </div>
          </div>
          <div className="text-base font-semibold text-[#221A51] flex-shrink-0">
            {formatCurrency(purchase.amount)}
          </div>
        </div>
      </div>
    </div>
  );
};
